import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import en from '@angular/common/locales/en';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { QRCodeModule } from 'angularx-qrcode';
import {
  NgZorroAntdModule, NzCheckboxModule, NzDatePickerModule, NzFormModule, NzInputModule,
  NzInputNumberModule,
  NzModalModule,
  NzModalService,
  NzNotificationModule, NzSelectModule,
  NzStepsModule
} from 'ng-zorro-antd';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { ModalModule } from "ngx-bootstrap";
import { NgxCaptchaModule } from "ngx-captcha";
import { NgxDocViewerModule } from "ngx-doc-viewer";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { NgxMaskModule } from "ngx-mask";
import { NgxSpinnerModule } from "ngx-spinner";
import { AppComponent } from './app.component';
import { BookingComponent } from './components/booking/booking.component';
import { CheckComponent } from './components/check/check.component';
import { EformComponent } from './components/eform/eform.component';
import { CheckboxComponent } from './components/eform/field-type/checkbox/checkbox.component';
import { DateCheckboxComponent } from './components/eform/field-type/date-checkbox/date-checkbox.component';
import { DateComponent } from './components/eform/field-type/date/date.component';
import { DateTimeComponent } from './components/eform/field-type/datetime/datetime.component';
import { LabelComponent } from './components/eform/field-type/label/label.component';
import { EformModalComponent } from './components/eform/field-type/modals/eform-modal/eform-modal.component';
import { TableComplexModalComponent } from './components/eform/field-type/modals/table-complex-modal/table-complex-modal.component';
import { MultipleChoiceComponent } from './components/eform/field-type/multiple-choice/multiple-choice.component';
import { NumberCurrencyComponent } from './components/eform/field-type/number-currency/number-currency.component';
import { NumberComponent } from './components/eform/field-type/number/number.component';
import { RadiobuttonComponent } from './components/eform/field-type/radiobutton/radiobutton.component';
import { SingleSelectComponent } from './components/eform/field-type/single-select/single-select.component';
import { TableComplexComponent } from './components/eform/field-type/table-complex/table-complex.component';
import { TextCheckboxComponent } from './components/eform/field-type/text-checkbox/text-checkbox.component';
import { TextComponent } from './components/eform/field-type/text/text.component';
import { TextAreaComponent } from './components/eform/field-type/textarea/textarea.component';
import { TitleComponent } from './components/eform/field-type/title/title.component';
import { ToolTipComponent } from './components/eform/field-type/tooltip/tooltip.component';
import { AboutComponent } from './components/email/about/about.component';
import { ConfirmEmailComponent } from './components/email/confirm-email/confirm-email.component';
import { ContactComponent } from './components/email/contact/contact.component';
import { HasAlreadyConfirmComponent } from './components/email/has-already-confirm/has-already-confirm.component';
import { NopeReceiveEmailComponent } from './components/email/nope-receive-email/nope-receive-email.component';
import { UrlNotCorrectComponent } from './components/email/url-not-correct/url-not-correct.component';
import { VerifyEmailSuccessComponent } from './components/email/verify-email-success/verify-email-success.component';
import { VerifyEmailComponent } from './components/email/verify-email/verify-email.component';
import { ErrorE204Component } from './components/error/error-e204/error-e204.component';
import { ErrorE400Component } from './components/error/error-e400/error-e400.component';
import { ErrorEqrcodeComponent } from './components/error/error-eqrcode/error-eqrcode.component';
import { ErrorWarningComponent } from './components/error/error-warning/error-warning.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { TransactionqueueComponent } from './components/transaction-queue/transaction-queue.component';
import { NumberOnly } from './directives/number-only-directive';
import { TelePhoneMaskDirective } from "./directives/phone-mask-directive";
import { ValidationMessagesComponent } from "./directives/validation-messages.component";
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { BookingService } from './services/booking.service';
import { CheckService } from './services/check.service';
import { EmailService } from './services/email.service';
import { HandShakeService } from './services/handshake.service';
import { BaseService } from './shared/base.service';

// Import what you need. RECOMMENDED. ✔️
import { DatePipe } from '@angular/common';
import { IconDefinition } from '@ant-design/icons-angular';
import { AccountBookFill, AlertFill, AlertOutline, MenuFoldOutline, MenuUnfoldOutline } from '@ant-design/icons-angular/icons';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { EformCompletedComponent } from './components/eform/eform-completed/eform-completed.component';
import { HomeComponent } from './components/home/home.component';
import { MultiStepComponent } from './components/multi-step/multi-step.component';
import { TransactionQueueTabletComponent } from './components/transaction-queue-tablet/transaction-queue-tablet.component';
import { AppBsModalModule } from './directives/appBsModal/app-bs-modal.module';
import { ErrorLocationComponent } from './errors/error-location/error-location.component';
import { ErrorPermissionLocationComponent } from './errors/error-permission-location/error-permission-location.component';
import { ConfigModule, ConfigService } from './services/config.service';
import { FormsService } from './services/forms.service';
import { MultiStepService } from './services/multi-step.service';
const icons: IconDefinition[] = [AccountBookFill, AlertOutline, AlertFill, MenuFoldOutline, MenuUnfoldOutline];

registerLocaleData(en);
export let AppInjector: Injector;

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    TransactionqueueComponent,
    TransactionQueueTabletComponent,
    PageNotFoundComponent,
    ErrorLocationComponent,
    ErrorPermissionLocationComponent,
    ValidationMessagesComponent,
    BookingComponent,
    HomeComponent,
    TelePhoneMaskDirective,
    NumberOnly,
    CheckComponent,
    EformComponent,
    EformModalComponent,
    ErrorEqrcodeComponent,
    ErrorWarningComponent,
    VerifyEmailComponent,
    VerifyEmailSuccessComponent,
    NopeReceiveEmailComponent,
    ConfirmEmailComponent,
    ErrorE204Component,
    ErrorE400Component,
    HasAlreadyConfirmComponent,
    MultiStepComponent,
    TextComponent,
    TitleComponent,
    ToolTipComponent,
    TableComplexComponent,
    SingleSelectComponent,
    DateComponent,
    DateTimeComponent,
    TextAreaComponent,
    CheckboxComponent,
    NumberCurrencyComponent,
    TextCheckboxComponent,
    DateCheckboxComponent,
    RadiobuttonComponent,
    MultipleChoiceComponent,
    NumberComponent,
    TableComplexModalComponent,
    LabelComponent,
    HeaderComponent,
    FooterComponent,
    EformCompletedComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxDatatableModule,
    NgSelectModule,
    NgxSpinnerModule,
    AppBsModalModule,
    NgxCaptchaModule,
    NgxDocViewerModule,
    NgxExtendedPdfViewerModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    ModalModule.forRoot(),
    RouterModule.forRoot([
      { path: '', component: BookingComponent, pathMatch: 'full' },
      { path: 'khdn-bieumau', component: HomeComponent, pathMatch: 'full' },
      { path: 'dat-hen-giao-dich', component: BookingComponent, pathMatch: 'full' },
      { path: 'lay-so-giao-dich', component: TransactionqueueComponent, pathMatch: 'full' },
      { path: 'lay-so-giao-dich-tablet', component: TransactionQueueTabletComponent, pathMatch: 'full' },
      { path: 'lay-so-giao-dich?errorCode=645', component: ErrorLocationComponent, pathMatch: 'full' },
      { path: 'lay-so-giao-dich?errorCode=646', component: ErrorPermissionLocationComponent, pathMatch: 'full' },
      { path: 'check', component: CheckComponent, pathMatch: 'full' },
      { path: 'Check', component: CheckComponent, pathMatch: 'full' },
      { path: 'page-not-found', component: PageNotFoundComponent, pathMatch: 'full' },
      { path: 'eform', component: EformComponent, pathMatch: 'full' },
      { path: 'eform?code=', component: EformComponent, pathMatch: 'full' },
      { path: 'eform-modal', component: EformModalComponent, pathMatch: 'full' },
      { path: 'error/eqrcode', component: ErrorEqrcodeComponent, pathMatch: 'full' },
      { path: 'error/warning', component: ErrorWarningComponent, pathMatch: 'full' },
      { path: 'xac-nhan-email-thanh-cong', component: VerifyEmailSuccessComponent, pathMatch: 'full' },
      { path: 'xac-nhan-tu-choi-nhan-email', component: NopeReceiveEmailComponent, pathMatch: 'full' },
      { path: 'link-khong-ton-tai', component: UrlNotCorrectComponent, pathMatch: 'full' },
      { path: 'xac-nhan-email', component: HasAlreadyConfirmComponent, pathMatch: 'full' },
      { path: 'About', component: AboutComponent, pathMatch: 'full' },
      { path: 'Contact', component: ContactComponent, pathMatch: 'full' },
      { path: 'xac-nhan', component: ConfirmEmailComponent, pathMatch: 'full' },
      { path: 'VerifyEmail', component: VerifyEmailComponent, pathMatch: 'full' },
      { path: 'multi-step', component: MultiStepComponent, pathMatch: 'full' },
      { path: 'eform-completed', component: EformCompletedComponent, pathMatch: 'full' },
    ]),
    NzIconModule.forRoot(icons),
    NgZorroAntdModule,
    NzSelectModule,
    NzInputModule,
    NzInputNumberModule,
    NzDatePickerModule,
    NzCheckboxModule,
    NzFormModule,
    NzModalModule,
    NzNotificationModule,
    NzStepsModule,
    QRCodeModule
  ],
  providers: [
    BaseService,
    HandShakeService,
    BookingService,
    CheckService,
    EmailService,
    MultiStepService,
    FormsService,
    NzModalService,
    ConfigService,
    DatePipe,
    ConfigModule.init(),
    { provide: NZ_I18N, useValue: en_US }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
